import React, { Component } from 'react';
import { withDomains, RESTExecutor } from '../../../lib/domain';
import { Table, Row, Button, Drawer, Divider, Input, message, Popconfirm } from 'antd';
import Title from 'antd/lib/typography/Title';
import { Link } from 'react-router-dom';
import HookEdit from './hook_edit';
import HookAddEdit from './addedit';
import { NetworkDelaySearch, overrideHeaderTitle, overrideHeaderBack, showErrorInNotification, formatMoney, showSuccessInNotification } from '../../../lib/util';
import ErrorWrapper from '../../../lib/error_wrapper';
import { BasicHeader } from '../../../components/basic_header';
import { setting_quick_menu } from '../../../util/ui_util';
import { TransparentButton } from '../../../components/basic_items';
import {PauseCircleFilled,PlayCircleFilled} from '@material-ui/icons';


const queryString = require('query-string');

const data_list = ({ props, onEditPressed, onDeletePressed ,onStatusChange}) => [
    {
        title: "Name",
        dataIndex: 'name',
        key: 'name',
    },
    {
        title: "Plugin ID",
        dataIndex: 'plugin_id',
        key: 'plugin_id',
    },
    
    {
        title: "Action",
        dataIndex: 'id',
        key: 'actions',
        render: (id, data) => {
            return <div style={{
                display:'flex',
                flexDirection:'row',
                alignItems:'center'
            }}> 
                <Button type='link' onClick={() => {
                    typeof onEditPressed === 'function' && onEditPressed(data);
                }}>Edit</Button>
                <Divider type='vertical'/>
                <Popconfirm
                        title="Are you sure you want to delete this hook?"
                        onConfirm={() => onDeletePressed(id)}
                        // onCancel={cancel}
                        okText="Yes"
                        cancelText="No"
                    >
                    <Button type='link' style={{color:'red'}}>Delete</Button>
                    </Popconfirm>
                
                {/* <Button type='link' style={{color:'red'}} onClick={()=>{
                    typeof onDeletePressed==='function' && onDeletePressed(id);
                }}>Delete</Button> */}
            </div>
        }
    }
]
class HookList extends Component {

    constructor(props) {
        super(props)

        this.state = {
            add_edit_status: null,
            edit_config_id: null,
            filter_query: {
            }
        };

        this.list_hooks = RESTExecutor.list().config({
            label: 'list',
        }).connect(props.domains.hook);

        // this.list_hooks.execute();

        this.patch_config = RESTExecutor.patch().config({
            label: 'detail',
          }).callbacks((success) => {
            message.success(success.result.message||"Update Successfull");
            this.list_hooks.execute()
      
          }, (error) => {
            showErrorInNotification(error)
              }).connect(props.domains.hook);

        this.deleteExecutor=RESTExecutor.delete().config({
            label:'detail'
        }).callbacks((success)=>{
            const newFilter={
                ...this.state.filter_query,
                page:1
            }
            this.setState({
                filter_query:newFilter
            })
            showSuccessInNotification(success,"Hook Deleted Successfully");
            this.list_hooks.config({
                params:newFilter
            }).execute();
        },(error)=>{
            showErrorInNotification(error);
        }).connect(props.domains.hook);


        this.delay_search = new NetworkDelaySearch();


    };

    stateUpdater = ({
        stateKey,
        valueKey,
        value,
        appendObj = {},
        callback
    }) => {
        let newData = this.state[stateKey];
        this.has_changed = true;
        if (valueKey) {
            newData[valueKey] = value;
        }
        if (appendObj) {
            Object.assign(newData, appendObj)
        }
        console.log(newData);
        this.setState({
            [stateKey]: newData
        }, () => {
            typeof callback === 'function' && callback()
        })
    }

    render() {
        let list_hooks_resp = this.list_hooks.response();
        let list_hooks_data = list_hooks_resp.result || {};
        let rowsData = list_hooks_data.rows || [];
        let rowsMeta = list_hooks_resp.meta || {};
        let patch_config_resp=this.patch_config.response();
        const { filter_query } = this.state;

        return (
            <div>
                <BasicHeader no_back title="Hooks"
                    menu_items={setting_quick_menu}
                    right={[
                        <TransparentButton
                            label="Add New"
                            className='cta-primary'
                            hint="Add New Hook"
                            onClick={() => {
                                this.setState({
                                    add_edit_status: 'add'
                                })
                            }}

                        />,
                    ]}

                />
                <div className='filter-card'>
                    <div className='filter-card-top' style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        flexWrap: 'nowrap',
                    }}>
                        <Input.Search
                                    placeholder="Search For"
                                    style={{
                                    }}
                                    autoFocus
                                    value={filter_query.query}
                                    onChange={(e) => {
                                        this.stateUpdater({
                                            stateKey: 'filter_query', valueKey: 'query', value: e.target.value, callback: () => {

                                                this.delay_search.onSearch(() => {
                                                    this.props.history.push({
                                                        // pathname:"users",
                                                        search: queryString.stringify({ ...this.state.filter_query, per_page: 100, page: 1 })
                                                    })
                                                })

                                            }
                                        })
                                    }}/>
                        </div>
                    </div>
                <ErrorWrapper
                error={list_hooks_resp}
                onReload={()=>{
                    this.list_hooks.execute()
                }}
                >

              
                <div className='default-card' style={{ padding: 0 }}>
                    <Table
                        className='main-table'
                        loading={list_hooks_resp.fetching||patch_config_resp.fetching}
                        size='small'
                        scroll={{ x: true }}
                        pagination={{
                            simple: false,
                            position: 'bottom',
                            onChange: (current, size) => {
                                this.props.history.push({
                                    search: queryString.stringify({ ...this.state.filter_query, per_page: size, page: current })
                                })
                            },
                            defaultCurrent: 1,
                            current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
                            // defaultPageSize: 20,
                            pageSize: (rowsMeta && rowsMeta.requested_count),

                            total: (rowsMeta && rowsMeta.total_count),
                            showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
                        }}
                        // bordered={false}
                        rowKey={(record) => record.id}
                        columns={data_list({
                            onEditPressed: (data) => {
                                this.setState({
                                    edit_config_id: data.id,
                                    add_edit_status: 'edit'
                                })
                            },
                            onDeletePressed:(id)=>{
                                this.deleteExecutor.forId(id).execute();
                            },
                            // onStatusChange:(id,data)=>{
                            //     this.patch_config.forId(id).execute(data)
                            // }
                        })}
                        dataSource={rowsData}
                    />

                  
                </div>
                </ErrorWrapper>
                  {/* For Fetcher Config Add */}
                  <Drawer
                        title="Hook Add"
                        placement="right"
                        closable={false}
                        width='50%'
                        destroyOnClose
                        onClose={() => {
                            this.setState({
                                add_edit_status: null
                            });
                            this.list_hooks.execute()
                        }}
                        visible={this.state.add_edit_status === 'add'}
                    >
                        <HookAddEdit
                            onClose={() => {
                                this.setState({
                                    add_edit_status: null
                                });
                                this.list_hooks.execute()
                            }}
                        // onRefreshClose={()=>{
                        //     this.list_hooks.execute();
                        //     this.setState({
                        //         add_edit_status:null
                        //     })
                        // }}

                        />
                    </Drawer>
                    <Drawer
                        title="Hook Edit"
                        placement="right"
                        closable={false}
                        width='50%'
                        destroyOnClose
                        onClose={() => {
                            this.setState({
                                add_edit_status: null
                            });
                            this.list_hooks.execute()
                        }}
                        visible={this.state.add_edit_status === 'edit'}
                    >
                        <HookEdit
                            config_id={this.state.edit_config_id}
                            onClose={() => {
                                this.setState({
                                    add_edit_status: null
                                });
                                this.list_hooks.execute()
                            }}
                        // onRefreshClose={()=>{
                        //     this.list_hooks.execute();
                        //     this.setState({
                        //         add_edit_status:null
                        //     })
                        // }}
                        />
                    </Drawer>
                
            </div>
        )
    }

    componentDidMount() {
        overrideHeaderTitle("Hooks");
        overrideHeaderBack(null);
        let new_filter_query = {};
        if (this.props.location && this.props.location.search) {
            const parsed = queryString.parse(this.props.location.search);
            new_filter_query = parsed;
        }
        this.setState({
            filter_query: {
                per_page: 100,
                page: 1,
                ...new_filter_query
            }
        }, () => {
            this.list_hooks.config({
                params: {
                    ...this.state.filter_query
                }
            }).execute()
        })



    }
    componentWillReceiveProps(nextProps) {

        let new_filter_query = {};
        if ((this.props.location.search !== nextProps.location.search)) {
            const parsed = queryString.parse(nextProps.location.search);
            new_filter_query = parsed;
            this.setState({
                filter_query: {
                    per_page: 100,
                    page: 1,
                    ...new_filter_query
                }
            }, () => {
                this.list_hooks.config({
                    params: {
                        ...this.state.filter_query
                    }
                }).execute()
            })
        } else {
            //   this.list_logs.execute()
        }


    }
}


export default withDomains(HookList, "hook");
